import styled from 'shared/utils/styled';

export const StyledTextarea = styled('textarea')(() => ({
  display: 'inline-flex',
  width: '100%',
  padding: '7px 9px',
  fontSize: 14,
  fontFamily: 'NeoSansStd',
  border: '1px solid rgba(34, 64, 96, 0.2)',
  color: '#224060',
  outline: 0,
  resize: 'none',
  '::placeholder': {
    color: 'rgba(34, 64, 96, 0.6)',
  },
}));
